<template>
  <modals-request
    v-model="payload"
    :request-class="proxyRequest"
    :disabled-send="disabled"
    :btn-attrs="attrs"
    label="Adicionar observação"
    title="Por favor, digite as informações da observação"
    :config-swal="config"
    persistent
    @success="success($event)"
  >
    <form-group>
      <v-row>
        <v-col cols="12">
          <input-select
            id="input:linked"
            v-model="payload.linked"
            label="Vínculo"
            :items="linkedOptions"
            :rules="[requiredRule]"
            outlined
            required
            disabled
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-textarea
            id="input:message"
            v-model="payload.message"
            label="Observação"
            :rules="[requiredRule]"
            counter
            outlined
            required
          />
        </v-col>
      </v-row>
    </form-group>
  </modals-request>
</template>

<script>
import AnalysisTableRequest from 'Modules/contacard/analysisTable/AnalysisTableRequest';
import ModalsRequest from '@/app/arch/components/modals/ModalsRequest.vue';
import FormGroup from '@/app/arch/components/crud/components/FormGroup.vue';
import RulesMixin from '@/app/arch/mixins/RulesMixin';
import observationLinkedType from 'Arch/enums/observationLinkedType';

export default {
  name: 'CreateAnalysisObservationModal',
  components: { ModalsRequest, FormGroup },
  mixins: [RulesMixin],
  data: () => ({
    requestClass: AnalysisTableRequest,
    payload: {
      linked: 'Client',
      message: '',
      registerClientId: '',
      type: 'System',
    },
    config: {
      successMessage: 'Sucesso ao criar observação para um cliente!',
      errorMessage: 'Falha ao criar observação para um cliente!',
    },
    linkedOptions: observationLinkedType,
  }),
  computed: {
    proxyRequest() {
      return () => this.requestClass.createObs(
        this.payload,
      );
    },
    clientId() {
      return this.analysisTable.payload.registerClientId;
    },
    disabled() {
      return Object.keys(this.payload)
        .map((key) => !this.payload[key])
        .find((bool) => bool);
    },
    attrs() {
      return {
        color: '#2ABD49',
        outlined: true,
        ...this.$attrs,
      };
    },
  },
  watch: {
    clientId: {
      immediate: true,
      handler(id) {
        if (id) {
          this.payload.registerClientId = id;
        }
      },
    },
  },
  methods: {
    success(ev) {
      this.$emit('success', ev);
    },
  },
  inject: {
    analysisTable: {
      default() {
        return {
          payload: {
            registerClientId: '',
          },
        };
      },
    },
  },
};
</script>
